(function ($) {
    
  $(document).ready(function () {
    var swiper = new Swiper(".support-slider", {
      slidesPerView: 3,
      spaceBetween: 22,
      loop: false,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          centeredSlides: true,
        },
        750: {
          loop: false,
          slidesPerView: 3,
          spaceBetween: 22,
          centeredSlides: false,
        },
        // 1024: {
        //   slidesPerView: 5,
        //   spaceBetween: 50,
        // },
      },
    });



    // var sliderV3c = new Swiper(".slider-v3c.swiper", {
    //   slidesPerView: 1,
    //   spaceBetween: 0,
    //   speed: 1200,
    //   parallax: true,
    //   loop: true,
    //   centeredSlides: false,
    //   // autoplay: {
    //   //   delay: 5000,
    //   //   disableOnInteraction: false,
    //   // },
    //   navigation: {
    //     nextEl: ".slider-v3c .slider-button--next",
    //     prevEl: ".slider-v3c .slider-button--prev",
    //   },
    //    on: {
    //     init: function () {
    //       document.querySelector('.slider-button--prev').removeAttribute('disabled');
    //       document.querySelector('.slider-button--next').removeAttribute('disabled');
    //     },
    //     slideChange: function () {
    //       document.querySelector('.slider-button--prev').removeAttribute('disabled');
    //       document.querySelector('.slider-button--next').removeAttribute('disabled');
    //     }
    //   }
    // });


    
    let swiperInstance;
    let formulaSwiperInstance;
    
    function initMobileSwiper() {
      const isMobile = window.innerWidth < 750;
    
      if (isMobile) {
        if (!swiperInstance) {
          swiperInstance = new Swiper('.landing-logos-slider .swiper', {
            loop: true,
            freeMode: true,
            autoplay: {
              delay: 0,
              disableOnInteraction: false,
            },
            loopAddBlankSlides: true,
            slidesPerView: 2.5,
            speed: 5000,
            grabCursor: true,
            loopAdditionalSlides: 2,
          });
        }
    
        if (!formulaSwiperInstance) {
          formulaSwiperInstance = new Swiper(".formula-science-slider", {
            slidesPerView: 1,
            spaceBetween: 22,
            loop: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = undefined;
        }
    
        if (formulaSwiperInstance) {
          formulaSwiperInstance.destroy(true, true);
          formulaSwiperInstance = undefined;
        }
      }
    }
    
    window.addEventListener('load', initMobileSwiper);
    window.addEventListener('resize', initMobileSwiper);
    
    
    $(".story-tab-sec .tabs_item_wrapper .tab-item .button").click(function () {
      var tabId = $(this).parents(".tab-item").attr("data-target");
      $(".story-tab-sec .tabs_item_wrapper .tab-item .button").removeClass(
        "active"
      );
      $(".story-tab-sec .tabs-content_wrapper .tab-content").removeClass(
        "active"
      );
      $(this).addClass("active");
      $("#" + tabId).addClass("active");
    });
    $(
      ".story-tab-sec .tabs_item_wrapper .tab-item:first-of-type .button"
    ).click();
  
    $(".multitabs .tabs_item_wrapper .tab-item .button").click(function () {
      var tabId = $(this).parents(".tab-item").attr("data-target");
      $(".multitabs .tabs_item_wrapper .tab-item .button").removeClass("active");
      $(".multitabs .tabs-content_wrapper .tab-content").removeClass("active");
      $(this).addClass("active");
      $("#" + tabId).addClass("active");
    });
    $(".multitabs .tabs_item_wrapper .tab-item:first-of-type .button").click();


    /*----------------header-------------------*/
    $("header summary.header__menu-item").on("mouseenter", function () {
        const $this = $(this);
        const $megaMenu = $this.closest(".mega-menu");
        const $content = $this.next(".mega-menu__content");
        // Toggle aria-expanded and add active class
        if ($this.attr("aria-expanded") === "true") {
            $this.removeAttr("aria-expanded");
            $megaMenu.removeAttr("open");
        } else {
            $this.attr("aria-expanded", "true");
            $megaMenu.attr("open", "true");
        }
    });

    // Close menu on mouse leave
    $(".mega-menu").on("mouseleave", function () {
        $(this).removeAttr("open").find("summary.header__menu-item").removeAttr("aria-expanded");
    });


    $('.product .modify-box li, .bundle-includes li').prepend(`<span class="tick-icon"><svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.75 7.09473L6.125 11.4697C9.875 6.46973 13 2.09473 13 2.09473" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
</svg></span>`);

      /*------------------popup-------------------*/
    $('.product .modify-box .custom-text').click(function (e) {
        e.preventDefault();
        $(this).closest('.modify-box').find('.modal-popup-container').addClass('active');
    })
    $('.product .card-bundle-sdk .modal-popup-container .icon-close').click(function (e) {
        e.preventDefault();
        $(this).closest('.modal-popup-container').removeClass('active');
    })
    $(document).click(function(event){
      var len = $(event.target).closest('.modal-popup-container, .custom-text').length;
      if(!len){
        $('.modal-popup-container').removeClass('active');
      }
    })

    /*----------------account desktop popup ------------------*/
      const $icon = $('.header-account-menu .header__icon--account');
      const $menu = $('.header-account-menu .menu-drawer__menu');
    
      $icon.on('click', function (e) {
        e.preventDefault();
        $menu.addClass('active');
      });
    
      $(document).on('click', function (e) {
        if (!$icon.is(e.target) && !$menu.is(e.target) && !$menu.has(e.target).length) {
          $menu.removeClass('active');
        }
      });

       const inputSelector = '.custom-product-bundle .selling_plan_option input';
        const activeClass = 'selected';
        $(inputSelector).on('change', function () {
          $('.custom-product-bundle .selling_plan_option').removeClass(activeClass);
          if ($(this).is(':checked')) {
            $(this).closest('.selling_plan_option').addClass(activeClass);
          }
        });
        $(inputSelector + ':checked').each(function () {
          $(this).closest('.selling_plan_option').addClass(activeClass);
        });
  });
  
  $(window).on("load resize", function () {
    var winWidth = $(window).width();
    if (winWidth < 750) {
      $(".need-info-sec .multicolumn-card__info .inline-richtext").append(
        '<span class="toggle-btn"></span>'
      );
      $(".need-info-sec .multicolumn-card__info .inline-richtext").click(
        function () {
          $(this).toggleClass("active").siblings(".rte").slideToggle();
        }
      );
      $(
        ".need-info-sec .multicolumn-card__info:first-of-type .inline-richtext"
      ).click();
    }
    var containerWidth = $(".page-width-desktop").width();
    var padding = (winWidth - 1370) / 2;
    if (winWidth > 1370) {
      $(".touch-with-right .page-width-desktop").css("padding-left", padding);
    } else if (winWidth > 750) {
      $(".touch-with-right .page-width-desktop").css("padding-left", "7rem");
    } else {
      $(".touch-with-right .page-width-desktop").css("padding-left", "2rem");
    }
  
   // Unbind previous events
    // $(".custom-information-sec h3.inline-richtext").off("click touchstart");
    // if (winWidth < 989) {
    //   $(".custom-information-sec h3.inline-richtext").on("touchstart click", function (e) {
    //     e.preventDefault();
    //     e.stopPropagation(); // ← prevents auto open/close on mobile
    //     const $wrapper = $(this).closest(".custom-information-sec");
    //     const $currentRow = $(this).closest(".grid__item");
    //     if ($currentRow.hasClass("active")) {
    //       $currentRow.removeClass("active").find(".rte").slideUp();
    //     } else {
    //       $wrapper
    //         .find(".grid__item")
    //         .not($currentRow)
    //         .removeClass("active")
    //         .find(".rte")
    //         .slideUp();
    //       $currentRow.addClass("active").find(".rte").slideDown();
    //     }
    //   });
    //   requestAnimationFrame(() => {
    //     requestAnimationFrame(() => {
    //       $(".custom-information-sec .grid__item:first-of-type h3.inline-richtext")
    //         .trigger("click");
    //     });
    //   });

    // } else {
    //   $(".custom-information-sec .grid__item").removeClass("active");
    //   $(".custom-information-sec .rte").removeAttr("style");
    // }


    if (winWidth < 989) {
      $(".custom-information-sec h3.inline-richtext").on("touchstart click", function (e) {
        e.preventDefault();
        // e.stopPropagation();

        const $wrapper = $(this).closest(".multicolumn-list");
        const $currentRow = $(this).closest(".multicolumn-list__item");
        const $content = $currentRow.find(".rte");

        if ($currentRow.hasClass("active")) {

          // Close current
          $content.stop(true, true).slideUp();
          $currentRow.removeClass("active");

        } else {

          // Close all others first
          $wrapper
            .find(".multicolumn-list__item")
            .not($currentRow)
            .removeClass("active")
            .find(".rte")
            .stop(true, true)
            .slideUp();

          // Open current
          $currentRow.addClass("active");
          $content.stop(true, true).slideDown();
        }
      });

      /* ⭐ Default First Accordion Open */
      const $first = $(".custom-information-sec .multicolumn-list .multicolumn-list__item").first();
      $first.addClass("active");
      $first.find(".rte").slideDown();
    }
    

     
  });


   function getBreakpoint() {
    const width = window.innerWidth;
    return width > 1024 ? 'desktop' : 'mobile';
}

function setupMenuInteraction() {
    const breakpoint = getBreakpoint();
    const $link = $('.quiz-description a');
    const _href = $link.attr('href');
    if(_href == '#'){
      $link.off(); // Remove previous event handlers
  
      if (breakpoint === 'desktop') {
          $link
              .on('mouseenter', function () {
                  $('#greeneScaleModal').addClass('active');
              })
              .on('mouseleave', function () {
                  $('#greeneScaleModal').removeClass('active');
              })
              .on('click', function (e) {
                  // Prevent default even on desktop
                  e.preventDefault();
                  e.stopPropagation();
              });
      } else {
          $link.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              $('#greeneScaleModal').addClass('active');
          });
      }
    }
}

setupMenuInteraction(); // Initial run
$(window).on('resize', setupMenuInteraction); // Reapply on resize

// Modal close button
$('.modal__close').click(function () {
    $(this).closest('.modal').removeClass('active');
});

})(jQuery);


// Function to handle drawer opening and closing
function handleCartDrawerState() {
  //console.log('Cart drawer state changed');
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && cartDrawer.classList.contains('active')) {
    document.documentElement.classList.add('minicart-open');
  } else {
    document.documentElement.classList.remove('minicart-open');
  }
}

// Function to modify the HTML when the recharge-bundles widget is loaded
// function modifyRechargeBundles() {
//   const rechargeBundles = document.querySelector('.rb-form');
//   if (rechargeBundles) {
//     let bundleTitle = document.querySelector('.rb-bundle-title');
//     let incentivesContainer = document.querySelector('.rb-incentives-status__container');
//     if (bundleTitle && incentivesContainer) {
//       let parent = incentivesContainer.parentNode;
//       parent.insertBefore(bundleTitle, incentivesContainer);
//     } else {
//       console.error('Required elements not found in the DOM.');
//     }

//     let bundleDescription = document.querySelector('.rb-bundle-description');
//     if (bundleDescription) {
//       let parent = rechargeBundles.parentNode;
//       parent.insertBefore(bundleDescription, rechargeBundles);
//     } else {
//       console.error('Required elements not found in the DOM.');
//     }
//   }
// }



document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.querySelector('.sticky-cta-sec');

  const bannerSection = document.querySelector('.banner-landing-page');
  const formulaSection = document.querySelector('.formula-science-section');
  const bundleSection = document.querySelector('.custom-product-bundle');
  const supportSection = document.querySelector('.custom-journey-support');
  const shopNowActionButtons = document.querySelectorAll('a.button.button--primary[href="#landing-featured-product"]:not([data-ele="sticky-button"]), .card-bundle-sdk .bundle-collection-actions');
  
  

  function isPast(el) {
    if (!el) return false;
    return el.getBoundingClientRect().bottom < 0;
  }

  function isInView(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function handleStickyBtn() {
    let anyButtonVisible = false;
    shopNowActionButtons.forEach(button => {
      if (isInView(button)) {
        anyButtonVisible = true;
      }
    });
    if (anyButtonVisible) {
      stickyBtn.style.display = 'none';
    } else {
      stickyBtn.style.display = 'block';
    }
  }
  
  /*
  function handleScrollMobile() {
    const pastBanner = isPast(bannerSection);
    const inFormula = isInView(formulaSection);
    const inBundle = isInView(bundleSection);
    const inSupport = isInView(supportSection);
    
    if (inSupport || inBundle || inFormula || !pastBanner) {
      stickyBtn.style.display = 'none';
    } else {
      stickyBtn.style.display = 'block';
    }
  }
  */

  window.addEventListener('scroll', () => {
    if (!stickyBtn) return;
    handleStickyBtn();
  });
});



/*
function modifyRechargeBundles() {
  const rechargeBundles = document.querySelector('.rb-sticky-form .rb-form');
  if (rechargeBundles) {
    let rbHeader = document.querySelector('.rb-header');
    let bundleTitle = document.querySelector('.rb-bundle-title');
    let bundleDescription = document.querySelector('.rb-bundle-description');
    let incentivesContainer = document.querySelector('.rb-incentives-status__container');
    let rbStickyForm = document.querySelector('.rb-sticky-form');
    let existingBuildBoxHeader = document.querySelector('.build-a-box-header');
    let productsContainer = document.querySelector('.rb-box-builder');
    if (existingBuildBoxHeader) {
      return;
    }
    if (bundleTitle && incentivesContainer && rbStickyForm) {
      let buildBoxHeaderEle = document.createElement('div');
      buildBoxHeaderEle.className = 'build-a-box-header';
      let buildBoxHeaderInnerEle = document.createElement('div');
      buildBoxHeaderInnerEle.className = 'build-a-box-header-inner';
      buildBoxHeaderEle.appendChild(buildBoxHeaderInnerEle);

      let headerColumnEleLeft = document.createElement('div');
      headerColumnEleLeft.className = 'build-a-box-header-column column-left';

      let headerColumnEleRight = document.createElement('div');
      headerColumnEleRight.className = 'build-a-box-header-column column-right';

      headerColumnEleLeft.appendChild(bundleTitle);
      headerColumnEleLeft.appendChild(incentivesContainer);
      
      let formParent = rechargeBundles.parentNode;
      formParent.insertBefore(bundleDescription, rechargeBundles);
      headerColumnEleRight.appendChild(rbStickyForm);
      

      buildBoxHeaderInnerEle.appendChild(headerColumnEleLeft);
      buildBoxHeaderInnerEle.appendChild(headerColumnEleRight);

      let parent = rbHeader.parentNode;
      parent.insertBefore(buildBoxHeaderEle, rbHeader);

      let heading = document.createElement('h2');
      heading.textContent = "What’s In Your Bundle";
      productsContainer.insertBefore(heading, productsContainer.firstChild);
      
    } else {
      console.error('Required elements not found in the DOM.');
    }
  }
}

let rbFormFound = false;

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    // Check for class changes in the cart-drawer
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      handleCartDrawerState();
    }

    // Check for the addition of the recharge-bundles widget, but only if it hasn't been found yet
    if (!rbFormFound && mutation.type === 'childList') {
      if (document.querySelector('.rb-form')) {
        modifyRechargeBundles();
        rbFormFound = true;
      }
    }
  }
});

// Observe the document body for child changes (for recharge-bundles) and attribute changes (for cart-drawer)
observer.observe(document.body, { attributes: true, childList: true, subtree: true });



document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.header .help-content-block').forEach(menu => {
    menu.style.display = 'none';
  });

  document.querySelectorAll('.header .help-label-block').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const content = button.nextElementSibling;
      const caret = button.querySelector('.collapsible-icon');
      const isOpen = content.style.display === 'block';

      // Close all other menus and reset caret rotation
      document.querySelectorAll('.header .help-content-block').forEach(menu => {
        menu.style.display = 'none';
      });
      document.querySelectorAll('.header .help-label-block .collapsible-icon').forEach(icon => {
        icon.classList.remove('rotate');
      });

      // Toggle current menu
      content.style.display = isOpen ? 'none' : 'block';

      // Toggle caret rotation
      if (!isOpen) {
        caret.classList.add('rotate');
      } else {
        caret.classList.remove('rotate');
      }
    });
  });

  document.querySelector('#Details-menu-drawer-resources-quizzes .menu-drawer__menu-item')?.click();
});
*/


// document.addEventListener("DOMContentLoaded", function () {
//     const details = document.getElementByClassName("header__menu-item");
//     details.addEventListener("mouseenter", function () {
//       details.parents('.mega-menu').setAttribute("open", "true");
//     });
//     details.addEventListener("mouseleave", function () {
//       details.removeAttribute("open");
//     });
// });



//MenupauseQuiz

document.addEventListener("DOMContentLoaded", function () {
    const wrappers = document.querySelectorAll('[data-ele="image-with-text-wrapper-iframe"]');
    wrappers.forEach(wrapper => {
      const trigger = wrapper.querySelector('a[data-load-iframe="true"]');
      const iframeWrapper = wrapper.querySelector('[data-ele="iframe-wrapper"]');
      const defaultTextWrapper = wrapper.querySelector('[data-ele="image-with-text-default-container"]');


      if (trigger && iframeWrapper) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();

          const iframeSrc = this.getAttribute("data-href");

          // Clear any existing iframe
          iframeWrapper.innerHTML = "";

          // Add loading class
          iframeWrapper.classList.add("loading");

          // Create iframe
          const iframe = document.createElement("iframe");
          iframe.src = iframeSrc;
          iframe.width = "100%";
          iframe.height = "600";
          iframe.style.border = "none";

          iframe.onload = function () {
            iframeWrapper.classList.remove("loading");
          };
          if (defaultTextWrapper) {
            defaultTextWrapper.classList.add("hidden");
          }
          iframeWrapper.appendChild(iframe);
          
        });
      }
    });

    window.addEventListener('message', function (event) {
      // console.log(event);
      if (event.data?.type === 'setHeight') {
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach(iframe => {
          if (iframe.contentWindow === event.source) {
            iframe.style.height = event.data.height + 'px';
          }
        });
      }
      if (event.data?.type === 'quizExited') {
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach(iframe => {
          if (iframe.contentWindow === event.source) {
            const wrapper = iframe.closest('[data-ele="image-with-text-wrapper-iframe"]');
            if (wrapper) {
              const defaultTextWrapper = wrapper.querySelector('[data-ele="image-with-text-default-container"]');
              if (defaultTextWrapper) {
                defaultTextWrapper.classList.remove("hidden");
              }
            }
            iframe.remove();
          }
        });
      }
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const sliderInstances = new Map(); // keep track of swiper instances
   document.querySelectorAll(".v2-slider .slider-v3c").forEach(slider => {
    if (!slider.parentElement.classList.contains("inner-wrapper")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("inner-wrapper");
      slider.parentNode.insertBefore(wrapper, slider);
      wrapper.appendChild(slider);
    }
  });
  function initSliders() {
    document.querySelectorAll(".multicolumn-list.slider").forEach(list => {
      const parent = list.parentElement;
      const wrapper = list.closest(".v2-slider"); // outer container
      const id = list.id || Math.random().toString(36).substr(2, 9); // unique key
      const isDesktop = window.innerWidth >= 989;
      const isMobile = window.innerWidth < 989;

      const shouldEnable =
        (list.classList.contains("slider--desktop") && isDesktop) ||
        (list.classList.contains("slider--mobile") && isMobile);

      // If slider should be active
      if (shouldEnable) {
        if (!sliderInstances.has(id)) {
          // add swiper classes
          list.classList.add("swiper-wrapper");
          if (parent) parent.classList.add("swiper");
          list.querySelectorAll(".multicolumn-list__item").forEach(item =>
            item.classList.add("swiper-slide")
          );

          // init Swiper
          const swiper = new Swiper(parent, {
            slidesPerView: "auto",
            speed: 1200,
            parallax: true,
            loop: false,
            navigation: {
              nextEl: parent.querySelector(".slider-button--next"),
              prevEl: parent.querySelector(".slider-button--prev"),
            },
          });

          sliderInstances.set(id, swiper);
        }

        // ✅ add class to .v2-slider wrapper
        if (wrapper) wrapper.classList.add("slideractive");

      } else {
        if (sliderInstances.has(id)) {
          const swiper = sliderInstances.get(id);
          swiper.destroy(true, true);
          sliderInstances.delete(id);

          // cleanup classes
          list.classList.remove("swiper-wrapper");
          if (parent) parent.classList.remove("swiper");
          list.querySelectorAll(".multicolumn-list__item").forEach(item =>
            item.classList.remove("swiper-slide")
          );
        }

        // ❌ remove class when slider disabled
        if (wrapper) wrapper.classList.remove("slideractive");
      }
    });
  }

  // Run on load
  initSliders();

  // Run again on resize (debounced)
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSliders, 200);
  });


  document.querySelector('[href="#klaviyo-form"]')?.addEventListener('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RXWdsb']);
  });

  
});


document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".products-list .grid__item:first-of-type .card-wrapper .card__media .media");

  if (!slider) return;

  // Add active class initially
  slider.classList.add("active");

  let lastScrollLeft = 0;

  slider.addEventListener("scroll", () => {
    // Trigger only if horizontal scrolling actually happened
    if (slider.scrollLeft !== lastScrollLeft) {
      slider.classList.remove("active");
    }

    lastScrollLeft = slider.scrollLeft;
  });



    function matchHeight() {
      const pairs = document.querySelectorAll(".products-list-container");

      pairs.forEach(pair => {
        const left = pair.querySelector(".products-list-sidebar");
        const right = pair.querySelector(".products-list");

        if (left && right) {
          left.style.height = ""; // reset for resize
          left.style.height = right.offsetHeight + "px";
        }
      });
    }

    window.addEventListener("load", matchHeight);
    window.addEventListener("resize", matchHeight);
});
